import React from 'react'
import BuildIcon from '@mui/icons-material/Build'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'

import Skeleton from 'components/CarSettings/Common/Creation/Summary/Skeleton'
import TranslationItem from 'components/CarSettings/Common/Creation/Summary/TranslationItem'
import SummaryItem from 'components/Common/SummaryItem'

import { textFiles } from 'constants/textFiles'
import useTranslation from 'hooks/useTranslation'
import { TransmissionCreationProps } from 'utils/CarSettings/Transmission/creation'

import { SectionContainer } from 'styles/creation'

const Summary = ({
  handleBack,
  transmissionData,
  handleSubmit,
  submitLoading,
}: TransmissionCreationProps) => {
  const { text: generalText } = useTranslation(textFiles.GENERAL)
  const { text } = useTranslation(textFiles.TRANSMISSION_CREATION)
  const { summary } = text
  const { transmissionInformation } = transmissionData
  const { translations } = transmissionInformation

  return (
    <Skeleton
      previousFunction={handleBack}
      nextFunction={handleSubmit}
      title={summary.title}
      description={summary.description}
      submitLoading={submitLoading}
    >
      <SectionContainer>
        <SummaryItem
          title={summary.name}
          text={transmissionInformation.name}
          icon={<BuildIcon />}
        />
        <SummaryItem
          title={summary.status}
          text={generalText.status[transmissionInformation.status]}
          icon={<CheckCircleIcon />}
        />
        {translations.length > 0 ? (
          <TranslationItem
            translations={transmissionInformation.translations}
          />
        ) : null}
      </SectionContainer>
    </Skeleton>
  )
}

export default Summary
